import { render, staticRenderFns } from "./_remittances.vue?vue&type=template&id=689e4cf8&scoped=true&"
import script from "./_remittances.vue?vue&type=script&lang=js&"
export * from "./_remittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e4cf8",
  null
  
)

export default component.exports